import { hyphenate as hyphenEn } from "hyphen/en";
import { hyphenate as hyphenIs } from "hyphen/is";

const HyphenateText = (target: Element) => {
  const str = target.innerHTML;
  const { lang } = document.documentElement;

  const hyphenate = lang === "is"
    ? hyphenIs
    : hyphenEn;

  const method = {
    init: () => {
      if (!str) return;

      hyphenate(str).then((res: string) => {
        target.innerHTML = res;
      });
    },

  };

  method.init();
};

export default HyphenateText;
